import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'pra-review',
  templateUrl: './pra-review.component.html',
  styleUrls: ['./pra-review.component.css']
})
/** PraReview component*/
export class PraReviewComponent implements OnInit {
  /** PraReview ctor */
  today: Date = new Date();
  PublisherList: any; TaskList: any; ReasonList: any;
  UserLeadList: any; FilterUserList: any; JournalList: any;
  showModal: boolean;
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any; dataTable: any;

  constructor() {

  }
  ngOnInit() {
    try {
      
      ApiMethod.getBaseUrl();
      customfunctions.SetDateValues("#txtFilterFromDtList", "#txtFilterToDtList");
      $('#divFilterPanel').css('height', (GlobalConstants.size.height));
      $('#divFilter').css('height', (GlobalConstants.size.height) - 80);

      try {
        $("#ddlFilterTeamLead,#ddlFilterAllocatedUser,#ddlFilterJournal,#ddlFilterTaskName,#ddlFilterStatus")
          .select2({
            placeholder: "Select", dropdownParent: "#divFilterPanel"
          });
      } catch (e) {
        console.log(e);
      }

      this.getDateTypeList();
      this.GetPublisherList();
      this.GetJournalList();
      this.GetUserLeadList();
      this.GetFilterUserList();

      this.GetPraList('Month');

      this.setDateTypeOptions();

    } catch (e) {
      console.log(e);
    }
    
  }

  dateTypes = [];

  getDateTypeList() {
    this.dateTypes = [
      { value: 'DownloadDate', text: 'Download' },
      { value: 'SubmissionDate', text: 'Submission' },
      { value: 'CompletionDate', text: 'Completion' },
      { value: 'QueryDate', text: 'Query' },
      { value: 'QueryResolvedDate', text: 'Resolved Date' }
    ];
  }


  setDateTypeOptions() {
    this.getDateTypeList();
    const tabName = this.getActiveTabTitle();

    if (tabName === 'Queries' || tabName === 'Query Resolved') {
      // Keep only QueryDate and QueryResolvedDate
      this.dateTypes = this.dateTypes.filter(x =>
        x.value === 'QueryDate' ||
        x.value === 'QueryResolvedDate'
      );
    } else {
      // Remove QueryDate and QueryResolvedDate
      this.dateTypes = this.dateTypes.filter(x =>
        x.value !== 'QueryDate' &&
        x.value !== 'QueryResolvedDate'
      );
    }
  }

  GetPublisherList(): void {
    ApiMethod.getMethod('/api/pra/publist/' + localStorage.aLoginID).subscribe(
      result => {
        this.PublisherList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetJournalList() {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherId: $('#ddlFilterPulisher').val(),
    };
    ApiMethod.postMethod('pra/PRAJournalConfig', dashboardPostData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.JournalList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetUserLeadList(): void {

    ApiMethod.getMethod('/api/pra/userlist/true/0').subscribe(
      result => {
        this.UserLeadList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetFilterUserList(): void {
    let leadId = $('#ddlFilterTeamLead').val();
    ApiMethod.getMethod('/api/pra/userlist/false/' + leadId).subscribe(
      result => {
        this.FilterUserList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetPraList(tabType, filterPanel = 0) {

    this.HideFilterPanel();
    $("#LoadingImage").show();
    var data = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: $("#txtFilterFromDtList").val(),
      ToDate: $("#txtFilterToDtList").val(),
      DateType: $("#ddlFilterDateType").val(),
      FilterPanel: filterPanel,
      TabType: tabType,
      AllocatedUser: $("#ddlFilterAllocatedUser").val() ? $("#ddlFilterAllocatedUser").val().join(',') : "All",
      JournalCode: $("#ddlFilterJournal").val() ? $("#ddlFilterJournal").val().join(',') : "All",
      TaskName: $("#ddlFilterTaskName").val() ? $("#ddlFilterTaskName").val().join(',') : "All",
      TaskStatus: $("#ddlFilterStatus").val() ? $("#ddlFilterStatus").val().join(',') : "All",
      FeedbackType: $("#ddlFilterFeedbackType").val(),
    }
       

    try {

      this.dataTable = $(this.table.nativeElement);

      if ($.fn.DataTable.isDataTable(this.dataTable[0])) {
        const dt = this.dataTable.DataTable();
        dt.clear();
        dt.destroy();
      }


    } catch (e) {
      console.log("DataTable destroy error:", e);
    }

    try {

      this.dataTable.find('thead').empty();
      this.dataTable.find('tbody').empty();

    } catch (e) {
      console.log("DataTable destroy error:", e);
    }

    ApiMethod.postMethod('pra/praservicesreview', data).subscribe(
      response => {

        this.dataSet = JSON.stringify(response.datalist); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = response.collist; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.filterPanel = true;
        dataItem.colsetting = false;
        dataItem.aNewButtonName = 'btn_QAResponse';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });

  }

  ShowFilterPanel() {
    this.setDateTypeOptions();
    $('#divFilterPanel').show();
  }

  HideFilterPanel() {
    $('#divFilterPanel').hide();
  }

  getFiltered() {
    this.GetPraList(this.getActiveTabTitle(), 1);
  }

  getActiveTabTitle(): string {
    const activeTab = document.querySelector('#ulTabList a.active') as HTMLElement;
    return activeTab?.getAttribute('title') || '';
  }

  ResetPopupFilter() {

    // Clear multiple-select dropdowns
    [
      '#ddlFilterAllocatedUser',
      '#ddlFilterJournal',
      '#ddlFilterTaskName',
      '#ddlFilterStatus'
    ].forEach(id => {
      $(id).val([]).trigger('change');
    });

    // Reset single-select dropdown
    $('#ddlFilterTeamLead').val(0).trigger('change');
  }


  //Show Status control popup
  show(): void {
    $('#txtResponse').val('');
    this.showModal = true;
  }

  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
  }

  updateQAResponse() {
    if ($('#txtResponse').val() == '') {
      ngswal("Failed !", 'Please enter Query Response !', "warning");
    }
    var data = {
      Id: localStorage.aEID,
      LoginId: localStorage.aLoginID,
      QueryResponse: $('#txtResponse').val()
    }

    $("#LoadingImagePopup").show();
    ApiMethod.postMethod('pra/update_qaresponse', data).subscribe(
      response => {
        $("#LoadingImagePopup").hide();
        if (response.status) {
          this.showModal = false;
          ngswal("Updated !", response.message, "info");
          this.GetPraList(this.getActiveTabTitle());
        }
        else {
          ngswal("Failed !", response.message, "warning");
        }
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });

  }

}
